import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading/Loading";
import { useLocation, useHistory } from "react-router-dom";
import { requestHandler } from "../../services/requestHandler";

export default function Callback() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(search);
  const tap_id = searchParams.get("tap_id");
  const type = searchParams.get("type");

  const retrieveCharge = async () => {
    try {
      let tamara_order_id =
        searchParams.get("orderId") ||
        searchParams.get("order_id") ||
        sessionStorage.getItem("tamara_order_id");
      let payload = { type };
      if (tap_id) {
        payload.tap_id = tap_id;
      }
      if (tamara_order_id) {
        payload.tamara_order_id = tamara_order_id;
      }

      if (type === "tamara" && !tamara_order_id) {
        history.push(
          `/payment/response?status=Failed&message=${encodeURIComponent(
            "Tamara order id missing from callback."
          )}`
        );
        return;
      }

      console.log(tamara_order_id, tap_id, "tamara_order_id");
      const response = await requestHandler(
        "POST",
        "payment/retrieve-charge",
        payload,
        dispatch
      );

      if (response) {
        console.log(response, "response");
        history.push(
          `/payment/response?status=${response.status}&message=${encodeURIComponent(
            response.message || ""
          )}`
        );
      } else {
        history.push(
          `/payment/response?status=Failed&message="Transaction Failed"`
        );
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Transaction Failed";
      history.push(
        `/payment/response?status=Failed&message=${encodeURIComponent(message)}`
      );
    }
  };
  useEffect(() => {
    retrieveCharge();
  }, [search]);

  return <Loading />;
}
